/**
 * Filtra proveedores por razón social, nombre de fantasía, CUIT, email o contacto.
 * @param {Array<Object>} providers Proveedores.
 * @param {string} term Texto buscado.
 * @returns {Array<Object>}
 */
export const filterProviders = (providers = [], term = '') => {
  const normalized = term.trim().toLowerCase();
  if (!normalized) return providers;
  const digits = normalized.replace(/\D/g, '');
  return providers.filter((provider) =>
    [provider.legal_business_name, provider.company, provider.email, provider.contact_information]
      .some((value) => String(value || '').toLowerCase().includes(normalized))
    || (digits && String(provider.cuit || '').replace(/\D/g, '').includes(digits))
  );
};
